import React from 'react';
import { node } from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';

import styles from './Scrollbars.module.scss';

function ScrollBlock(props) {
  const { children } = props;

  return (
    <PerfectScrollbar className={styles.scrollBlock}>
      {children && children}
    </PerfectScrollbar>
  );
}

ScrollBlock.propTypes = {
  children: node.isRequired,
};

export default ScrollBlock;
